export default {
  // layout
  LAYOUT: {
    sidebar: {
      ___logoTitle: 'COMPASS株式会社',
      ___tryButton01: '試す',
      ___tryButton02: 'InheriNextを',
      menuOption: {
        title: {
          ___phenotype: '表現型',
          ___genePanel: 'パネル',
          ___disease: '疾患',
          ___introduction: 'イントロダクション'
        }
      }
    },
    header: {
      ___webTitle: 'InheriNext Expert',
      ___logoTitle: 'COMPASS株式会社'
    },
    footer: {
      ___companyTitle: 'COMPASS株式会社'
    },
    uploading: {
      ___default: 'アップロード中'
    },
    dialog: {
      selectIdentity: {
        ___title: 'あなたは医療関係者ですか？',
        option: {
          ___patient: '患者または<br>患者の家族',
          ___doctor: '医師'
        }
      },
      phenotypeMore: {
        ___title: '単一遺伝子の結果'
      },
      toast: {
        title: {
          ___success: '成功',
          ___error: 'エラー'
        },
        content: {
          ___jobFailed: '失敗しました。'
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___mainTitle: 'Inherinext Search Tools',
      introduction: {
        ___alert: 'The results from the above search tools are only for reference, not for diagnosis.',
        title: {
          ___overview: 'Overview',
          ___phenotype: 'Phenotype',
          ___genePanel: 'Gene Panel'
        },
        content: {
          ___overview01: 'This website, developed by Compass Bioinformatics Inc., provides users with search tools related to phenotypes and genes of inherited diseases. If you want to experience more comprehensive functionalities related to inherited disease detection, please try InheriNext.',
          ___overview02: 'Compass Bioinformatics Inc. is a software development company dedicated to translating genetic data into clinically useful information. InheriNext is our flagship product, providing healthcare professionals with comprehensive genetic information for better medical judgments in genetic and rare diseases.',
          ___phenotype01: 'Users can input phenotypes using Human Phenotype Ontology (HPO) numbers or terms. Our system then calculates the correlation between these characteristics and genes, displaying the most relevant diseases associated with the identified genes. Additionally, we describe the consistency between the entered phenotype and the suggested diseases.',
          ___genePanel01: 'Users can search for relevant gene panels by entering disease or phenotype terms. The system then presents a list of associated genes collected from the literature for their reference. Additionally, users have the option to download the gene list to assist in further analysis or review.'
        }
      }
    },
    genePanel: {
      ___title01: '興味のある疾患を入力し、',
      ___title02: '関連遺伝子リストを取得する。',
      geneTag: {
        ___placeholder: '疾患または遺伝子パネルを入力してください。'
      },
      introduction: {
        ___content01: '例）Marfan syndrome、Leber hereditary optic neuropathy、Fabry disease, Epilepsy、Noonan and RASopathiesなど。'
      }
    },
    phenotypeDisease: {
      ___title01: '表現型を入力し、',
      ___title02: '最も関連性の高い遺伝子と疾患を検索する。',
      ___selectedTitle: '選択済み',
      phenotypeTag: {
        ___placeholder: '表現型を入力'
      },
      introduction: {
        ___content01: '例）Global developmental delay、Short stature、Hypotonia、Nystagmus、Hearing impairment、Intellectual disability、Microcephalyなど。'
      },
      result: {
        ___phenotypeTitle: 'インポートした表現型',
        ___tableTitle: '結果',
        alert: {
          ___content01: '結果はあくまでも参考で、',
          ___content02: '診断のためではありません。'
        }
      },
      table: {
        ___more: '詳細',
        title: {
          ___gene: '遺伝子',
          ___disease: '疾患',
          ___phenotype: '表現型ネットワーク',
          ___phenotypeMobile: '表現型'
        }
      },
      uploading: {
        ___pleaseWait: 'ページを離れずにしばらくお待ちください。'
      }
    },
    resourceMap: {
      ___title: 'リソースマップ',
      filterOption: {
        title: {
          ___country: '国を入力',
          ___city: '市を入力',
          ___hospital: '病院名を入力',
          ___department: '診療科を入力'
        }
      }
    }
  },
  // component
  COMPONENT: {
    resourceMap: {
      data: {
        infoOption: {
          title: {
            ___doctor: '医師',
            ___address: '住所',
            ___hospital: '病院名',
            ___department: '専門分野'
          }
        }
      }
    },
    phenotypeDisease: {
      pathDetail: {
        text: {
          ___text01: 'これは、条件に関連するHPOに直接マッピングされます。',
          ___text02: 'これは、条件に関連するHPOに直接マッピングされます。',
          ___text03: '類似性のパスは、提供されたHPOの用語から<b>{length}</b>つの近傍を介した条件に関するHPOの用語への連結で示す。'
        }
      }
    },
    tool: {
      geneTag: {
        ___empty: '該当する結果は見つかりませんでした。',
        info: {
          ___gene: '遺伝子',
          ___genePanel: '遺伝子パネル',
          ___phenotype: '表現型',
          ___condition: '疾患',
          ___add: '追加'
        },
        title: {
          ___gene: '遺伝子',
          ___genePanel: 'パネル',
          ___phenotype: '表現型',
          ___condition: '疾患'
        }
      },
      phenotypeTag: {
        info: {
          ___phenotype: '表現型',
          ___disease: '疾患',
          ___add: '追加'
        },
        title: {
          ___phenotype: '表現型',
          ___disease: '疾患'
        },
        ___empty: '該当する結果は見つかりませんでした。'
      }
    }
  },
  // common
  COMMON: {
    button: {
      ___add: '追加',
      ___download: 'ダウンロード',
      ___back: '戻る',
      ___find: '取得',
      ___search: '検索',
      ___cancel: 'キャンセル',
      ___resourceMap: 'リソースマップ'
    },
    toast: {
      ___noPermission: '権限がありません。',
      ___pleaseLogin: 'ログインしてください。',
      ___pageNotFound: 'ページが見つかりません。',
      ___phenotypesAnalyzeLimit: '{amount}以上の表現型を解析することはできません。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/ja/lang.js